/**
 * Performs a shallow comparison of two arrays (1-level deep).
 *
 * @param {Array} array1 - the first array to compare.
 * @param {Array} array2 - the second array to compare.
 * @returns {Boolean} - true if both arrays are shallow equal, false if not.
 **/
const isArrayShallowEqual = (array1 = [], array2 = []) => {
  if (array1 === array2) {
    return true;
  }

  // shallow compare the two arrays one level deep
  return (
    array1.length === array2.length &&
    array1.every((item, index) => item === array2[index])
  );
};

export default isArrayShallowEqual;
export { isArrayShallowEqual };
